import {Box} from "@scope/scope-one-ui/core";
import {SIZES} from "@scope/scope-one-ui/theme";
import styled from "styled-components";


const UserListWrapper = styled(Box)`
  max-height: ${SIZES.spacing(15)};
  overflow: scroll;
`

export const Styled = {
  UserListWrapper
}
